import React from 'react';
import { Route, Routes } from "react-router-dom";
import { useFormData } from "../context";
import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import StepProgressBar from '../components/steps/StepProgressBar';
import TitleBar from '../components/TitleBar';
import Footer from '../components/Footer';
import NameInfoStep from '../components/steps/NameInfoStep';
import AddressInfoStep from '../components/steps/AddressInfoStep';
import ConstituencyTemplateStep from '../components/steps/ConstituencyTemplateStep';
import FormSubmitted from '../components/FormSubmitted';
import FormCompleted from '../components/FormCompleted';
import FormAlreadyCompleted from '../components/FormAlreadyCompleted';
import useWindowSize from '../hooks/useWindowSize';

export default function ConstituencyCampaignMultiStepForm({ session, provider, isEmbedded }) {
    // Declare variables using const or let
    const apiProvider = provider;
    const steps = JSON.parse(session.steps);
    const { data } = useFormData();
    const { width } = useWindowSize();

    // Declare state variables using useState
    const routes = steps.map((step) => buildRoutes(step));
    const request = {
        id: session.formId,
        sessionId: session.id,
        type: session.type,
        fields: { user: data.user && data.user, address: data.address && data.address, agreement: data.agreement, constituency: data.constituency },
        template: data.template
    };

    const storageValues = session && [
       `df.${session.formId}.const`,
       `df.${session.templateId ?? session.template.templateId}.let`,
       `data.${provider.key}`
    ];

    // Declare event handlers or other functions
    function buildRoutes(schema) {
        const params = { route: schema.path, nextRoute: schema.next, prevRoute: schema.prev, provider: schema.api === true ? apiProvider : null, session: schema.session === true ? session : null, purposeId: session.purposeId, isMultiStep: session.isMultiStep };
        const newRoute = {
            exact: true,
            path: schema.path,
            element: getComponent(schema.component, params)
        };

        return newRoute;
    }

    function getComponent(componentName, params) {
        // eslint-disable-next-line default-case
        switch (componentName) {
            case "NameInfoStep":
                return <NameInfoStep {...params} />
            case "AddressInfoStep":
                return <AddressInfoStep {...params} />
            case "ConstituencyTemplateStep":
                return <ConstituencyTemplateStep {...params} />
        }
    }

    // Render JSX using state variables and other variables
    return (
        <div id="form" className={`container-fluid ${!isEmbedded ? '' : 'mx-0'}`} style={ isEmbedded ? { paddingRight: 0, paddingLeft: 0 } : { } }>
            {!isEmbedded && <TitleBar key="title" data={session} />}
            <div className="e-card nofocus nohover">
                <div className="col-12 pb-5">
                    <div className="e-card-header">
                        <div className="e-card-header-caption">
                            <div className="e-card-header-title">
                                {(session.isTestMode || session.isTestCampaign) && (<MessageComponent severity="Info" variant="Filled" content={(width > 300 ? "Campaign Testing - Will send to test mailbox" : "Campaign Testing")}></MessageComponent>)}
                                <StepProgressBar steps={steps} />
                            </div>
                        </div>
                    </div>
                    <div className="e-card-content">
                        <div className="content-wrapper pb-3">
                            <Routes>
                                {routes.map((step, index) => (<Route key={index} exact path={step.path} element={step.element} />))}
                                <Route exact path="/submitted" element={<FormSubmitted provider={apiProvider} request={request} />} />
                                <Route exact path="/alreadysubmitted" element={<FormAlreadyCompleted session={!isEmbedded ? session : null} storageValues={storageValues} />} />
                                <Route exact path="/completed" element={<FormCompleted session={!isEmbedded ? session : null} storageValues={storageValues} />} />
                            </Routes>
                        </div>
                    </div>
                </div>
            </div>
       
            {!isEmbedded && <Footer tenant={session.tenant} />}
        </div>
    );
}